import { ADHERENCE_HISTORY_PAGINATION } from '../actions';

const initialState = {
	protocol: 1,
	book: 1,
	event: 1,
	ondemand: 1,
};

export default function(state = initialState, action) {
	switch(action.type) {
		case ADHERENCE_HISTORY_PAGINATION:
			const { tabType, nextPage } = action.payload;
			return {
				...state,
				[tabType]: nextPage,
			};
		default:
			return state;
	}
}